import { useState } from 'react';
import { Link } from 'react-router-dom';
import { BellAlertIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { useInbox } from '../hooks/useComms';

// Non-blocking acknowledgement REMINDER (was a forced full-screen gate).
// Boss's rule (2026-08-05): never force acknowledgement — an engineer may not
// have time to read + ack right now, so they can dismiss this and come back
// later. The message stays flagged "Acknowledgement needed" in the inbox (and
// the reader keeps its acknowledge button) until they acknowledge it; this
// banner just nudges them so it isn't forgotten, and re-shows on the next app
// load while any remain outstanding. Fail-open: if the inbox can't load, nothing
// shows.
function AckGate() {
  const { data: messages } = useInbox();
  const [dismissed, setDismissed] = useState(false);
  const outstanding = (messages || []).filter((m) => m.requires_ack && !m.acknowledged_at);
  if (!outstanding.length || dismissed) return null;

  const n = outstanding.length;
  // Oldest first — "Open" takes them straight to the longest-waiting one.
  const oldest = [...outstanding].sort((a, b) => new Date(a.created_at) - new Date(b.created_at))[0];

  return (
    <div className="fixed inset-x-0 bottom-4 z-40 flex justify-center px-4 print:hidden">
      <div className="flex w-full max-w-lg items-center gap-3 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 shadow-lg">
        <BellAlertIcon className="h-5 w-5 shrink-0 text-amber-600" />
        <span className="min-w-0 flex-1 text-sm font-medium text-amber-900">
          {n === 1
            ? 'You have a message awaiting your acknowledgement.'
            : `You have ${n} messages awaiting your acknowledgement.`}
        </span>
        <Link
          to={`/messages/${oldest.id}`}
          onClick={() => setDismissed(true)}
          className="shrink-0 rounded-md bg-brand px-3 py-1.5 text-xs font-semibold text-white hover:bg-brand-dark"
        >
          {n === 1 ? 'Open' : 'Review'}
        </Link>
        <button
          type="button"
          onClick={() => setDismissed(true)}
          aria-label="Remind me later"
          title="Remind me later"
          className="shrink-0 rounded-md p-1 text-amber-700 hover:bg-amber-100"
        >
          <XMarkIcon className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
}

export default AckGate;
